import React, { useEffect, useRef, useState } from 'react'

import { IMG } from '../../../themes'
import { DESK_FLOOR_PLAN } from '../../../helpers'

export const DESK_SEARCH_TYPE = {
  DESK: 'desk',
  BOOKER: 'booker',
}

const SEARCH_TYPES = [
  { value: DESK_SEARCH_TYPE.DESK, label: DESK_FLOOR_PLAN.SEARCH_BY_DESK, placeholder: DESK_FLOOR_PLAN.SEARCH_DESK_PLACEHOLDER },
  { value: DESK_SEARCH_TYPE.BOOKER, label: DESK_FLOOR_PLAN.SEARCH_BY_BOOKER, placeholder: DESK_FLOOR_PLAN.SEARCH_BOOKER_PLACEHOLDER },
]

export const getDeskSearchLabel = (desk, type) => (
  type === DESK_SEARCH_TYPE.BOOKER ? desk.ownerName || desk.ownerEmail : desk.name
)

const getSearchableTexts = (desk, type) => (
  type === DESK_SEARCH_TYPE.BOOKER ? [desk.ownerName, desk.ownerEmail] : [desk.name]
)

export const findMatchedDesks = (desks, search) => {
  const keyword = search ? search.text.trim().toLowerCase() : ''
  if (!keyword) return []

  return desks.filter((desk) => getSearchableTexts(desk, search.type)
    .some((text) => String(text || '').toLowerCase().includes(keyword)))
}

const DeskSearch = ({ language, onSearch, onClose }) => {
  const [type, setType] = useState(DESK_SEARCH_TYPE.DESK)
  const [text, setText] = useState('')
  const [isTypeOpen, setIsTypeOpen] = useState(false)
  const typeRef = useRef(null)
  const inputRef = useRef(null)

  const selectedType = SEARCH_TYPES.find((item) => item.value === type)

  useEffect(() => {
    if (inputRef.current) inputRef.current.focus()
  }, [])

  useEffect(() => {
    if (!isTypeOpen) return undefined

    const handleClickOutside = (event) => {
      if (typeRef.current && !typeRef.current.contains(event.target)) setIsTypeOpen(false)
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [isTypeOpen])

  const handleSelectType = (value) => {
    setType(value)
    setIsTypeOpen(false)
    onSearch(null)
    if (inputRef.current) inputRef.current.focus()
  }

  const handleChangeText = (event) => {
    setText(event.target.value)
    if (!event.target.value.trim()) onSearch(null)
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    onSearch(text.trim() ? { type, text } : null)
  }

  return (
    <form className='desk-search' onSubmit={handleSubmit}>
      <input
        ref={inputRef}
        className='desk-search-input'
        value={text}
        placeholder={selectedType.placeholder[language]}
        onChange={handleChangeText}
      />

      <div className='desk-search-type' ref={typeRef}>
        <button type='button' className='desk-search-type-toggle' onClick={() => setIsTypeOpen((prev) => !prev)}>
          <span>{selectedType.label[language]}</span>
          <img src={IMG['chevron-down.svg']} alt='' />
        </button>
        {isTypeOpen && (
          <ul className='desk-search-type-list'>
            {SEARCH_TYPES.map((item) => (
              <li
                key={item.value}
                className={item.value === type ? 'active' : ''}
                onClick={() => handleSelectType(item.value)}
              >
                {item.label[language]}
              </li>
            ))}
          </ul>
        )}
      </div>

      <button type='submit' className='desk-modal-icon-button' aria-label='search'>
        <img src={IMG['ic_lucide_search.svg']} alt='' />
      </button>
      <button type='button' className='desk-modal-icon-button' aria-label='close search' onClick={onClose}>
        <img src={IMG['ic_lucide_x.svg']} alt='' />
      </button>
    </form>
  )
}

export default DeskSearch
